/* Insigne Personalizer — Faz 2: Three.js malzeme önizlemesi.
   Panel + gerçekçi malzemeler: temperli cam (clearcoat + yeşilimsi kenar),
   BEYAZ alüminyum (mat), fırçalı alüminyum (anizotropik metal),
   rulo kanvas (düzlem kısmen silindire sarılı — Ali mockup fikri).
   window.IP3D API: mount(el), show({texUrl, wMM, hMM, kind, material}), hide(). */
import * as THREE from './three.module.min.js';
import { OrbitControls } from './OrbitControls.js';
import { RoomEnvironment } from './RoomEnvironment.js';

var renderer = null, scene, camera, controls, group, raf = 0, host = null;

function ensure(el) {
  if (renderer) { if (host !== el) { host = el; el.appendChild(renderer.domElement); } return; }
  host = el;
  renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 0.95;
  el.appendChild(renderer.domElement);

  scene = new THREE.Scene();
  var pmrem = new THREE.PMREMGenerator(renderer);
  scene.environment = pmrem.fromScene(new RoomEnvironment(), 0.04).texture;

  camera = new THREE.PerspectiveCamera(32, 1, 0.05, 50);
  camera.position.set(0.15, 0.1, 2.2);

  /* ışık: ortam-tabanlı (yumuşak) — keskin nokta specular görseli YIKMASIN (Ali).
     zayıf key sadece hacim hissi verir; asıl aydınlatma environment + ambient. */
  var key = new THREE.DirectionalLight(0xfff4e6, 0.28);
  key.position.set(1.4, 1.8, 1.2);
  scene.add(key);
  scene.add(new THREE.AmbientLight(0xffffff, 0.55));
  scene.add(new THREE.HemisphereLight(0xffffff, 0xd8cfc0, 0.75));

  controls = new OrbitControls(camera, renderer.domElement);
  controls.enableDamping = true; controls.dampingFactor = 0.08;
  controls.enablePan = false;
  controls.minDistance = 1.1; controls.maxDistance = 3.4;
  controls.minPolarAngle = Math.PI * 0.18; controls.maxPolarAngle = Math.PI * 0.72;
  /* Müşteri sahneye dokunduğu an sinematik hareket bırakılır — kontrol her zaman onda. */
  renderer.domElement.addEventListener('pointerdown', function () { endIntro(); });
  renderer.domElement.addEventListener('wheel', function () { endIntro(); }, { passive: true });

  group = new THREE.Group();
  scene.add(group);

  window.addEventListener('resize', size);
}

function size() {
  if (!renderer || !host || !host.clientWidth) return;
  var w = host.clientWidth, h = host.clientHeight || Math.round(w * 0.75);
  renderer.setSize(w, h, false);
  renderer.domElement.style.width = '100%';
  renderer.domElement.style.height = '100%';
  camera.aspect = w / h; camera.updateProjectionMatrix();
}

function clearGroup() {
  while (group.children.length) {
    var o = group.children.pop();
    o.traverse && o.traverse(function (c) {
      if (c.geometry) c.geometry.dispose();
      if (c.material) { (Array.isArray(c.material) ? c.material : [c.material]).forEach(function (m) { m.dispose(); }); }
    });
  }
}

/* fırçalı metal için prosedürel çizgi dokusu */
function brushedTex() {
  var c = document.createElement('canvas'); c.width = 512; c.height = 512;
  var g = c.getContext('2d');
  g.fillStyle = '#9a9a98'; g.fillRect(0, 0, 512, 512);
  for (var i = 0; i < 2600; i++) {
    var y = Math.random() * 512, l = 40 + Math.random() * 200, a = 0.03 + Math.random() * 0.08;
    g.strokeStyle = 'rgba(' + (Math.random() > 0.5 ? '255,255,255' : '40,40,40') + ',' + a + ')';
    g.beginPath(); g.moveTo(Math.random() * 512, y); g.lineTo(Math.random() * 512 + l, y); g.stroke();
  }
  var t = new THREE.CanvasTexture(c);
  t.wrapS = t.wrapT = THREE.RepeatWrapping;
  return t;
}

/* BEJ pamuklu kanvas arka yüzü: örgü deseni doğrudan renk haritası (ışıktan bağımsız görünür) */
function weaveColorTex() {
  var c = document.createElement('canvas'); c.width = 512; c.height = 512;
  var g = c.getContext('2d');
  g.fillStyle = '#eee3cf'; g.fillRect(0, 0, 512, 512);          // bej taban
  for (var i = 0; i < 512; i += 4) {                             // örgü çizgileri
    g.strokeStyle = 'rgba(196,180,150,.5)';
    g.beginPath(); g.moveTo(0, i); g.lineTo(512, i); g.stroke();
    g.strokeStyle = 'rgba(214,199,170,.5)';
    g.beginPath(); g.moveTo(i, 0); g.lineTo(i, 512); g.stroke();
  }
  for (var k = 0; k < 900; k++) {                                // pamuk lif kırpıntısı
    g.fillStyle = 'rgba(255,250,238,' + (0.05 + Math.random() * 0.1) + ')';
    g.fillRect(Math.random() * 512, Math.random() * 512, 2, 1);
  }
  var t = new THREE.CanvasTexture(c);
  t.wrapS = t.wrapT = THREE.RepeatWrapping; t.repeat.set(6, 6);
  t.colorSpace = THREE.SRGBColorSpace;
  return t;
}

/* kanvas dokusu için ince örgü bump */
function weaveTex() {
  var c = document.createElement('canvas'); c.width = 256; c.height = 256;
  var g = c.getContext('2d');
  g.fillStyle = '#808080'; g.fillRect(0, 0, 256, 256);
  g.strokeStyle = 'rgba(255,255,255,.25)';
  for (var i = 0; i < 256; i += 3) { g.beginPath(); g.moveTo(0, i); g.lineTo(256, i); g.stroke(); }
  g.strokeStyle = 'rgba(0,0,0,.22)';
  for (var j = 0; j < 256; j += 3) { g.beginPath(); g.moveTo(j, 0); g.lineTo(j, 256); g.stroke(); }
  var t = new THREE.CanvasTexture(c);
  t.wrapS = t.wrapT = THREE.RepeatWrapping; t.repeat.set(14, 14);
  return t;
}

function faceMaterial(matKey, tex) {
  if (matKey === 'glass') {
    /* gerçekçi cam (Ali: uzaktan yansıma görseli YIKMASIN): yansıma difüz görselin üstüne
       İNCE binen bir cila; clearcoatRoughness yüksekçe → geniş/yumuşak highlight, blow-out yok.
       Fresnel (ior 1.5) kenarlarda açıya göre parlamayı korur. */
    return new THREE.MeshPhysicalMaterial({
      map: tex, roughness: 0.14, metalness: 0,
      clearcoat: 0.7, clearcoatRoughness: 0.18,
      envMapIntensity: 0.32, reflectivity: 0.35, ior: 1.5, specularIntensity: 0.5,
    });
  }
  if (matKey === 'brushed') {
    var b = brushedTex();
    return new THREE.MeshStandardMaterial({
      map: tex, metalness: 0.78, roughness: 0.42,
      roughnessMap: b, envMapIntensity: 1.1,
    });
  }
  if (matKey === 'canvas') {
    return new THREE.MeshStandardMaterial({
      map: tex, metalness: 0, roughness: 0.94,
      bumpMap: weaveTex(), bumpScale: 0.0016, envMapIntensity: 0.5,
    });
  }
  /* aluminum — BEYAZ kaplamalı, mat (Ali: "alüminyum beyaz olacak") */
  return new THREE.MeshStandardMaterial({
    map: tex, metalness: 0.12, roughness: 0.6, envMapIntensity: 0.8,
  });
}

function sideMaterial(matKey) {
  if (matKey === 'glass') {
    return new THREE.MeshPhysicalMaterial({
      color: 0x9fd8c8, transmission: 0.7, thickness: 0.02,
      roughness: 0.15, metalness: 0, transparent: true, opacity: 0.9,
    });
  }
  if (matKey === 'brushed') return new THREE.MeshStandardMaterial({ color: 0xb9b9b7, metalness: 0.85, roughness: 0.4 });
  return new THREE.MeshStandardMaterial({ color: 0xf2f2f0, metalness: 0.05, roughness: 0.65 }); // beyaz alu kenarı
}


/* Surfboard silueti — PDF'ten birebir (Ali çizimi) */
var SURF_EXACT = {"start": [0.8962, 0.1864], "curves": [[0.7689, 0.047, 0.5538, 0.0076, 0.512, 0.0011], [0.507, 0.0004, 0.5016, 0.0, 0.4962, 0.0], [0.4909, 0.0, 0.4855, 0.0004, 0.4805, 0.0011], [0.4387, 0.0076, 0.2236, 0.047, 0.0964, 0.1864], [0.0323, 0.2566, 0.0, 0.3414, 0.0, 0.4388], ["L", 0.0, 0.4392], [0.0, 0.4512, 0.0005, 0.4633, 0.0015, 0.4756], [0.0125, 0.6142, 0.0854, 0.7777, 0.218, 0.9616], ["L", 0.2203, 0.9647], [0.2207, 0.9653, 0.2204, 0.9652, 0.2221, 0.9655], [0.4049, 1.0, 0.5876, 1.0, 0.7703, 0.9655], [0.7703, 0.9655, 0.7704, 0.9655, 0.7704, 0.9655], [0.7721, 0.9652, 0.7718, 0.9653, 0.7722, 0.9647], ["L", 0.7744, 0.9616], [0.9071, 0.7777, 0.98, 0.6142, 0.9911, 0.4756], [1.0, 0.3625, 0.9681, 0.2653, 0.8962, 0.1864]]};
/* ⚠ YATAYDA SİLÜET 90° DÖNER, GERİLMEZ — editördeki surfPathD ile AYNI
   dönüşüm: (u,v) → (v, 1−u). İki yerde ayrı matematik olsaydı ekrandaki
   şekil ile 3B gövde birbirini tutmazdı. Yön kutudan okunur (W > H). */

/* ⚠ HAM VEKTÖR [0,1] KUTUSUNA TAM OTURMUYOR (Ali 2026-10-07: "en sağ tarafı
   tam kenara yaslı değil"). Ölçüldü: u 0..0,9926 · v 0..0,9914 — sağda %0,74,
   altta %0,86 boşluk. Dikeyde boşluk ALTTA kalıp göze çarpmıyordu; 90°
   döndürünce SAĞ KENARA geçti ve hemen görüldü. Hata yeni değil, görünür oldu.
   Sınır kutusunu yüklenirken ÖLÇÜP [0,1]'e eşliyoruz: ham veri değişirse
   düzeltme kendiliğinden doğru kalır, elle düzeltilmiş sayılar bayatlardı. */
var SURF_KUTU = (function () {
  var xs = [], ys = [];
  function ekle(x, y) { xs.push(x); ys.push(y); }
  function egri(p0, p1, p2, p3) {
    for (var i = 0; i <= 24; i++) {
      var t = i / 24, m = 1 - t;
      ekle(m * m * m * p0[0] + 3 * m * m * t * p1[0] + 3 * m * t * t * p2[0] + t * t * t * p3[0],
           m * m * m * p0[1] + 3 * m * m * t * p1[1] + 3 * m * t * t * p2[1] + t * t * t * p3[1]);
    }
  }
  var o = SURF_EXACT.start;
  ekle(o[0], o[1]);
  SURF_EXACT.curves.forEach(function (c) {
    if (c[0] === 'L') { o = [c[1], c[2]]; ekle(o[0], o[1]); }
    else { egri(o, [c[0], c[1]], [c[2], c[3]], [c[4], c[5]]); o = [c[4], c[5]]; }
  });
  var x0 = Math.min.apply(null, xs), x1 = Math.max.apply(null, xs);
  var y0 = Math.min.apply(null, ys), y1 = Math.max.apply(null, ys);
  return { x0: x0, y0: y0, sx: 1 / (x1 - x0), sy: 1 / (y1 - y0) };
})();
function surfN(u, v) {
  return [(u - SURF_KUTU.x0) * SURF_KUTU.sx, (v - SURF_KUTU.y0) * SURF_KUTU.sy];
}
function surfShape(W, H) {
  var s = new THREE.Shape();
  var yatay = W > H;
  function px(u, v) { var n = surfN(u, v); return ((yatay ? n[1] : n[0]) - 0.5) * W; }
  function py(u, v) { var n = surfN(u, v); return (0.5 - (yatay ? 1 - n[0] : n[1])) * H; }
  var s0 = SURF_EXACT.start;
  s.moveTo(px(s0[0], s0[1]), py(s0[0], s0[1]));
  SURF_EXACT.curves.forEach(function (c) {
    if (c[0] === 'L') s.lineTo(px(c[1], c[2]), py(c[1], c[2]));
    else s.bezierCurveTo(px(c[0], c[1]), py(c[0], c[1]),
                         px(c[2], c[3]), py(c[2], c[3]),
                         px(c[4], c[5]), py(c[4], c[5]));
  });
  s.closePath();
  return s;
}
/* panel arka yüzü — Ali: CAM=beyaz, ALÜMİNYUM(brushed)=gri (emissive ile her açıda net) */
function backMaterial(matKey) {
  if (matKey === 'glass') return new THREE.MeshStandardMaterial({
    color: 0xffffff, roughness: 0.6, metalness: 0, emissive: 0xffffff, emissiveIntensity: 0.5 });
  return new THREE.MeshStandardMaterial({
    color: 0x9c9c9c, roughness: 0.62, metalness: 0.1, emissive: 0x9c9c9c, emissiveIntensity: 0.35 });
}

/* ÖZEL ASKI APARATI (Ali) — camın/alünün ARKASINA yapışan kısım (duvar plakası HARİÇ):
   10cm×7cm dış plaka + ortada geçme dili. Metal gri. Arka yüzden ~6mm çıkıntı. */
function hangerMesh(s) {
  var g = new THREE.Group();
  var metal = new THREE.MeshStandardMaterial({ color: 0xc4c4c4, metalness: 0.5, roughness: 0.42,
    emissive: 0x8a8a8a, emissiveIntensity: 0.25 });
  var hw = 70 * s, hh = 100 * s, pt = 1.6 * s;        // plaka 7×10cm, 1.6mm sac
  // ana plaka (cama yapışık)
  var plate = new THREE.Mesh(new THREE.BoxGeometry(hw, hh, pt), metal);
  plate.position.z = -pt / 2;
  g.add(plate);
  // geçme dili: ortada, arkaya doğru katlanmış kanca (üste açık geçme profili)
  var lipW = 34 * s, lipH = 30 * s, lipD = 5.5 * s;
  var lip = new THREE.Mesh(new THREE.BoxGeometry(lipW, lipH, 1.4 * s), metal);
  lip.position.set(0, hh * 0.08, -pt - lipD);         // arkaya çıkıntı
  g.add(lip);
  var top = new THREE.Mesh(new THREE.BoxGeometry(lipW, 1.4 * s, lipD), metal);
  top.position.set(0, hh * 0.08 + lipH / 2, -pt - lipD / 2);
  g.add(top);
  return g;
}

/* KÖPÜK PED (Ali) — 1cm×1cm, yükseklik 1.6cm; alt köşelerde, duvarda dengeli dursun diye */
function foamMesh(s) {
  var foam = new THREE.MeshStandardMaterial({ color: 0xf3f1ec, roughness: 0.95, metalness: 0 });
  return new THREE.Mesh(new THREE.BoxGeometry(10 * s, 10 * s, 16 * s), foam);
}

/* panelin arkasına donanım: askı(lar) üst-ortada (büyük ölçü 2 / küçük 1) + köpük altta.
   ⚠ Şekle göre konum (surf/round dar → donanım ŞEKLİN İÇİNDE kalsın, kenarda boşlukta değil). */
function attachHardware(g, W, H, backZ, s, wMM, big, kind) {
  var n = big ? 2 : 1;
  /* ⚠ YATAY SÖRFTE DONANIM AYARI AYRI (Ali 2026-10-07). Mevcut sörf değerleri
     UZUN-DAR tahtaya göreydi (yatay yayılım 0,10 = dar tahtada doğru). Yatay
     tahtada aynı değerler donanımı 90 cm'lik bir yüzeyin ortasına sıkıştırır.
     Yeni değerler siluet ÖRNEKLENEREK seçildi — döndürülmüş eğride askı
     yüksekliğinde (V=0,38) tahta merkezden ±0,477, köpük yüksekliğinde
     (V=0,82) ±0,39 genişliğinde; aşağıdaki yayılımlar bu sınırların içinde. */
  var surfYatay = kind === 'surf' && W > H;
  var hSpread = kind === 'surf' ? (surfYatay ? 0.28 : 0.10) : (kind === 'round' ? 0.16 : 0.22);
  var fSpread = kind === 'surf' ? (surfYatay ? 0.34 : 0.10) : (kind === 'round' ? 0.24 : 0.40);
  var fy = kind === 'surf' ? (surfYatay ? -H * 0.32 : -H * 0.30) : (kind === 'round' ? -H * 0.30 : -H * 0.40);
  var hy = kind === 'surf' ? (surfYatay ? H * 0.22 : H * 0.12) : H * 0.20;
  for (var i = 0; i < n; i++) {
    var hgr = hangerMesh(s);
    hgr.position.set(n === 1 ? 0 : (i === 0 ? -W * hSpread : W * hSpread), hy, backZ);
    g.add(hgr);
  }
  var fz = backZ - 8 * s;                              // köpük arka yüzden dışarı
  [[-W * fSpread, fy], [W * fSpread, fy]].forEach(function (p) {
    var f = foamMesh(s); f.position.set(p[0], p[1], fz); g.add(f);
  });
}

/* düz panel (rect/round/surf) — uvRect verilirse dokunun O bölgesi (çok-parçalı için) */
function buildFlatPanel(tex, W, H, kind, matKey, wMM, hMM, uvRect) {
  var s = H / hMM;                                     // sahne birimi / mm
  var TH = Math.max(0.006, 4 * s);                     // gerçek 4mm cam/panel kalınlığı
  var face = faceMaterial(matKey, tex), side = sideMaterial(matKey), back = backMaterial(matKey);
  var g = new THREE.Group();
  var mesh, backZ = -TH / 2;
  if (kind === 'surf') {
    // ön yüz (görsel) + arka yüz (BEYAZ) ayrı — Ali: arkada baskı görünmesin
    var frontGeo = new THREE.ShapeGeometry(surfShape(W, H));
    var fp = frontGeo.attributes.position, fuv = frontGeo.attributes.uv;
    for (var fi = 0; fi < fuv.count; fi++) fuv.setXY(fi, fp.getX(fi) / W + 0.5, fp.getY(fi) / H + 0.5);
    var frontMesh = new THREE.Mesh(frontGeo, face); frontMesh.position.z = TH / 2;
    var backMesh = new THREE.Mesh(new THREE.ShapeGeometry(surfShape(W, H)), back);
    backMesh.position.z = -TH / 2; backMesh.rotation.y = Math.PI;
    // ince kenar (extrude yalnız yan)
    var sgeo = new THREE.ExtrudeGeometry(surfShape(W, H), { depth: TH, bevelEnabled: false, curveSegments: 48 });
    sgeo.translate(0, 0, -TH / 2);
    var edge = new THREE.Mesh(sgeo, [new THREE.MeshBasicMaterial({ visible: false }), side]);
    g.add(edge); g.add(frontMesh); g.add(backMesh);
    attachHardware(g, W, H, backZ, s, wMM, wMM * hMM >= 640000, kind);
    return g;
  } else if (kind === 'round') {
    /* ⚠ ÖLÇÜLDÜ (2026-07-30): eskiden CylinderGeometry kullanılıyordu ve doku, silindirin
       KAPAK UV'sinden geliyordu; eksen döndürmeleriyle birlikte görsel 90° saat yönünün
       TERSİNE dönüyordu (4-renk test dokusu: sol-üst kırmızı yerine YEŞİL çıkıyordu).
       Artık surf ile aynı yol: düzlemsel ShapeGeometry + UV'leri ELLE düz panel gibi ver
       → yuvarlak da dikdörtgenle bire bir aynı haritalamayı kullanır, dönme imkânsız. */
    var circ = new THREE.Shape();
    circ.absarc(0, 0, W / 2, 0, Math.PI * 2, false);
    var rGeo = new THREE.ShapeGeometry(circ, 96);
    var rp = rGeo.attributes.position, ruv = rGeo.attributes.uv;
    for (var ri = 0; ri < ruv.count; ri++) ruv.setXY(ri, rp.getX(ri) / W + 0.5, rp.getY(ri) / H + 0.5);
    var rFront = new THREE.Mesh(rGeo, face); rFront.position.z = TH / 2;
    var rBack = new THREE.Mesh(new THREE.ShapeGeometry(circ, 96), back);
    rBack.position.z = -TH / 2; rBack.rotation.y = Math.PI;      // arkada baskı ASLA görünmez
    var rEdge = new THREE.ExtrudeGeometry(circ, { depth: TH, bevelEnabled: false, curveSegments: 96 });
    rEdge.translate(0, 0, -TH / 2);
    g.add(new THREE.Mesh(rEdge, [new THREE.MeshBasicMaterial({ visible: false }), side]));
    g.add(rFront); g.add(rBack);
    attachHardware(g, W, H, backZ, s, wMM, wMM * hMM >= 640000, kind);
    return g;
  } else {
    var geo2 = new THREE.BoxGeometry(W, H, TH);
    if (uvRect) {                                       // dokunun sadece bu panele düşen dilimi
      var uvb = geo2.attributes.uv;
      for (var vi = 0; vi < uvb.count; vi++) {
        uvb.setX(vi, uvRect.u0 + uvb.getX(vi) * (uvRect.u1 - uvRect.u0));
        uvb.setY(vi, uvRect.v0 + uvb.getY(vi) * (uvRect.v1 - uvRect.v0));
      }
    }
    mesh = new THREE.Mesh(geo2, [side, side.clone(), side.clone(), side.clone(), face, back]);
  }
  g.add(mesh);
  attachHardware(g, W, H, backZ, s, wMM, wMM * hMM >= 640000, kind);
  return g;
}

/* tek/çok parçalı montaj + zemin gölgesi */
function buildPanel(tex, W, H, kind, matKey, wMM, hMM, panels) {
  var g = new THREE.Group();
  if (panels) {                                        // ÇOK-PARÇALI: N ayrı panel + GERÇEK boşluk
    var s = H / hMM, gapMM = panels.gap_mm || 10, gap = gapMM * s;
    if (panels.layout === 'row') {
      var n = panels.count, pw = (W - (n - 1) * gap) / n;
      var uw = pw / W;                                  // dokuda panel genişliği oranı (boşluk hariç)
      for (var i = 0; i < n; i++) {
        var cx = -W / 2 + i * (pw + gap) + pw / 2;
        var u0 = (i * (pw + gap)) / W;
        var panel = buildFlatPanel(tex, pw, H, 'rect', matKey, wMM / n, hMM,
          { u0: u0, u1: u0 + uw, v0: 0, v1: 1 });
        panel.position.x = cx; g.add(panel);
      }
    } else {
      var cols = panels.cols, rows = panels.rows;
      var pw2 = (W - (cols - 1) * gap) / cols, ph2 = (H - (rows - 1) * gap) / rows;
      for (var r = 0; r < rows; r++) for (var c = 0; c < cols; c++) {
        var px = -W / 2 + c * (pw2 + gap) + pw2 / 2;
        var py = H / 2 - r * (ph2 + gap) - ph2 / 2;
        var uu0 = (c * (pw2 + gap)) / W, vv0 = (r * (ph2 + gap)) / H;
        var pnl = buildFlatPanel(tex, pw2, ph2, 'rect', matKey, wMM / cols, hMM / rows,
          { u0: uu0, u1: uu0 + pw2 / W, v0: 1 - (vv0 + ph2 / H), v1: 1 - vv0 });
        pnl.position.set(px, py, 0); g.add(pnl);
      }
    }
  } else {
    g.add(buildFlatPanel(tex, W, H, kind, matKey, wMM, hMM, null));
  }
  var shadow = new THREE.Mesh(
    new THREE.PlaneGeometry(W * 1.5, W * 0.5),
    new THREE.MeshBasicMaterial({ color: 0x000000, transparent: true, opacity: 0.16 })
  );
  shadow.rotation.x = -Math.PI / 2;
  shadow.position.y = -H / 2 - 0.06;
  g.add(shadow);
  return g;
}

/* KANVAS = zeminde serili DÖKÜMLÜ KUMAŞ (Ali): yumuşak dalgalar + sağ kenar üste
   katlanmış (katın üstü = BEJ baskısız arka yüz) + iki yüzde belirgin örgü dokusu.
   Doku haritası SARIM düzeninin tamamı: paylar + mirror + ters logo. */
/* SEKTÖR STANDARDI (CanvasChamp/Prodigi/Creatsy mockup kurgusu): KISMEN AÇILMIŞ RULO.
   Düz kısım eseri gösterir; sağ uç gevşek spiral ruloda, rulonun DIŞI krem arka yüz
   (baskı içe sarılır). Düz kısımda çok hafif doğal dalgalanma. */
var shadowMode = 'none';                 // Ali kararı 2026-07-29: zemin/gölge YOK
                                         // (ölçüldü: yere yatan kumaş görünür gölge oluşturmuyor,
                                         //  'yumuşak gölge' ile 'gölge yok' arasında %0.2 fark vardı)
/* Yumuşak temas gölgesi: kenarları dışa doğru tamamen eriyen radyal gradyan.
   Düz kenar bırakmadığı için ASLA levha gibi okunmaz. */
function shadowTex(soft) {
  var c = document.createElement('canvas'); c.width = c.height = 256;
  var g = c.getContext('2d');
  var gr = g.createRadialGradient(128, 128, 10, 128, 128, 126);
  gr.addColorStop(0, 'rgba(0,0,0,' + (soft ? 0.34 : 0.5) + ')');
  gr.addColorStop(0.45, 'rgba(0,0,0,' + (soft ? 0.18 : 0.3) + ')');
  gr.addColorStop(0.8, 'rgba(0,0,0,0.045)');
  gr.addColorStop(1, 'rgba(0,0,0,0)');
  g.fillStyle = gr; g.fillRect(0, 0, 256, 256);
  return new THREE.CanvasTexture(c);
}
function makeShadow(W, H, mode) {
  if (mode === 'none') return null;
  if (mode === 'studio') {                       // apaçık stüdyo zemini (üründen bariz farklı)
    var m = new THREE.Mesh(
      new THREE.PlaneGeometry(W * 3.2, H * 3.2),
      new THREE.MeshStandardMaterial({ color: 0xcdd2d6, roughness: 0.95, metalness: 0 })
    );
    m.rotation.x = -Math.PI / 2; m.position.y = -0.014;
    return m;
  }
  /* ⚠ ÖLÇÜLDÜ: gölge kumaşın tam altında olunca TAMAMEN örtülüyor ve "gölge var/yok"
     arasında görünür fark kalmıyor (piksellerin %7'si, ortalama fark %0.3 = gözle
     ayırt edilemez). Gerçek gölge ışığın TERS yönüne, nesnenin DIŞINA taşar. Yalayıcı
     ışık (-1.3, 0.30, 0.55) yönünde olduğu için gölgeyi +x / -z tarafına kaydırıyoruz. */
  var s = new THREE.Mesh(
    new THREE.PlaneGeometry(W * 1.75, H * 2.15),
    new THREE.MeshBasicMaterial({ color: 0x2e2a22, transparent: true, opacity: 0.62,
                                  alphaMap: shadowTex(true), depthWrite: false })
  );
  s.rotation.x = -Math.PI / 2;
  s.position.set(W * 0.085, -0.012, H * 0.10);
  return s;
}

/* rollLen parametreli sarım — ANİMASYONLU aç/kapa için her karede güncellenebilir */
/* ⭐ GERÇEK KUMAŞ FİZİĞİ — Verlet parçacık ağı (Ali: "uydurma değil, gerçekten bir
   kumaş açılırken nasıl dalgalanırsa öyle").

   Neden formül değil simülasyon: sönümlü bir sinüs dalgası kumaş GİBİ görünmüyor.
   Burada rulo KİNEMATİK (spiral matematiğiyle sürülür); rulodan çıkan her sıra
   rulonun o anki TEĞET HIZINI miras alır, sonra serbest kalır. Yerçekimi çeker,
   mesafe kısıtları komşularına iletir, zemin sürtünmesi söndürür → dalgalar
   kendiliğinden doğar, ilerler ve durur. Kimse dalga "çizmiyor".

   Köşe kıvrımı da uydurma değil: gerçek rulo kanvas, sarılı kaldığı için kenarlarda
   ŞEKİL HAFIZASI taşır. Bunu, ruloda EN SON kalan kenara uygulanan küçük ve azalan
   bir kaldırma kuvveti olarak modelliyoruz; kat, fizik oturunca kendi şeklini alır. */
function makeUnrollCloth(geo, W, H, NX, NY) {
  var pos = geo.attributes.position;
  var n = pos.count;
  var bx = new Float32Array(n), by = new Float32Array(n);      // dokunmamış düzlem koordinatları
  for (var i = 0; i < n; i++) { bx[i] = pos.getX(i); by[i] = pos.getY(i); }

  var X = new Float32Array(n), Y = new Float32Array(n), Z = new Float32Array(n);
  var oX = new Float32Array(n), oY = new Float32Array(n), oZ = new Float32Array(n); // önceki kare
  var free = new Uint8Array(n);                                // 0 = ruloda (kinematik)
  /* Serilmeye BAŞLANAN uç yerinde durur (gerçekte de onu tutar/sabitlersin). Bu uç
     serbest bırakılırsa kumaş zeminde usulca kayıp fazlalığını salar ve DÜMDÜZ olur
     (ölçtük: dinlenmede genlik 0.0000). Sabitlenince fazlalık burkulmak ZORUNDA kalır
     → kumaş oturduktan sonra da doğal dalgalanmasını korur. */
  var anchor = new Uint8Array(n);
  var aX = new Float32Array(n), aZ = new Float32Array(n);

  var R0 = Math.max(0.04, Math.min(W, H) * 0.082);   // rulo kalinligi (tup capina yakin)
  var restX = W / NX, restY = H / NY;
  var diag = Math.sqrt(restX * restX + restY * restY);
  var id = function (ix, iy) { return iy * (NX + 1) + ix; };

  /* kısıtlar: yatay + dikey (yapısal) ve çapraz (makaslama) — çapraz olmadan
     kumaş bez gibi değil, kağıt gibi kırışır */
  var ca = [], cb = [], cl = [];
  for (var iy = 0; iy <= NY; iy++) {
    for (var ix = 0; ix <= NX; ix++) {
      var a = id(ix, iy);
      /* Gerçek dokuma birebir düzgün değildir; bu küçük (±%1.2) sapma, kumaş oturduğunda
         tekrarsız ve doğal bir dalgalanma bırakır — mükemmel düz bir yüzey sahte durur. */
      var w1 = 1 + 0.012 * Math.sin(ix * 12.9898 + iy * 78.233);
      var w2 = 1 + 0.012 * Math.sin(ix * 39.346 + iy * 11.135);
      if (ix < NX) { ca.push(a); cb.push(id(ix + 1, iy)); cl.push(restX * w1); }
      if (iy < NY) { ca.push(a); cb.push(id(ix, iy + 1)); cl.push(restY * w2); }
      if (ix < NX && iy < NY) {
        ca.push(a); cb.push(id(ix + 1, iy + 1)); cl.push(diag);
        ca.push(id(ix + 1, iy)); cb.push(id(ix, iy + 1)); cl.push(diag);
      }
    }
  }
  var CA = Int32Array.from(ca), CB = Int32Array.from(cb), CL = Float32Array.from(cl);
  var NC = CA.length;

  var GRAV = -2.2 * Math.min(W, H);    // sahne ölçeğine göre yerçekimi (birim ≈ metre)
  var DAMP = 0.982;                    // hava sürtünmesi (dalga birkaç saniye yaşasın)
  var GROUND_FRICTION = 0.45;          // zeminde kayar, sonra durur — anında yapışmaz
  var ITER = 4;                     // fazlalik YATAYDA birikmesin, DIKEYE cozulsun

  function spiral(x, x0, R, out) {
    var arc = (x - x0) / R;
    var Reff = R * (1 + 0.055 * arc / (2 * Math.PI));
    out[0] = x0 + Reff * Math.sin(arc);
    out[2] = Reff * (1 - Math.cos(arc));
  }
  var tmp = [0, 0, 0];

  /* ⭐ DALGA BURADAN DOĞAR: gerçek bir ruloyu açarken kumaş, rulonun ilerlediği
     mesafeden biraz DAHA UZUN serilir (rulo bir miktar kayar, kumaş tepeden düşerken
     bollaşır). Bu fazlalık, gergin duramayıp BURKULUR — dalgalar budur. Gergin
     seren bir model matematiksel olarak dümdüz kalır (ölçtük: genlik 0.0000). */
  var SLACK = 0.0;               /* ⚠⚠ KALİBRASYONLA KAPATILDI (2026-07-30). "Rulo geride kalsın, fazlalık kumaş
     burkulup dalga olsun" fikri PRATİKTE ÇALIŞMADI: 0.018 / 0.030 / 0.045 / 0.060
     değerleri denendi — fazlalık arttıkça baskı eziliyor (aralık 0.71 → 0.27 → 0.10 →
     eksi) ama DALGA ARTMIYOR (hep ~0.002). Yani mekanizma dalga değil, yalnız yatay
     sıkışma üretiyor ve müşterinin görselini bozuyor. 3B görünüm bir ÜRÜN ÖNİZLEMESİ:
     sadakat efektin önünde gelir. Kalan hareket = rulodan düşüş + yerçekimiyle oturma,
     ki o gerçek fizik. */
  var SLACK_REST = 0.0;
  var slack = (typeof window !== 'undefined' && window.__ipSlack) || SLACK;  // kalibrasyon icin
  /* ⚠ ÖLÇÜLDÜ: fazlalık kumaş açılma bitince serbest UÇTA YIĞILIYOR ve orada kumaş
     KENDİ ÜSTÜNE KATLANIYOR (175 katlanma noktası, hepsi uçta) → ön ve arka yüz
     çakışıp "yırtılmış" gibi bir şerit veriyordu. Çözüm: fazlalık GEÇİCİ olsun —
     dalgayı yaratma işini bitirince yumuşakça salınsın, kumaş gergine yakın otursun. */
  function rollX(x0) { return x0 - slack * (x0 + W / 2); }
  var SLACK0 = SLACK;
  function relaxSlack() { slack += (SLACK_REST - slack) * 0.055; }

  function place(rollLen) {          // t=0: her şey ruloda ya da düz
    var x0 = W / 2 - rollLen;
    var R = R0 * (0.5 + 0.5 * Math.sqrt(Math.max(0, rollLen) / (W * 0.8)));
    for (var j = 0; j < n; j++) {
      var xw = rollX(x0);
      if (bx[j] > x0) { spiral(bx[j], xw, R, tmp); X[j] = tmp[0]; Z[j] = tmp[2]; free[j] = 0; }
      else { X[j] = bx[j]; Z[j] = 0; free[j] = 1; }
      Y[j] = by[j];
      oX[j] = X[j]; oY[j] = Y[j]; oZ[j] = Z[j];
      anchor[j] = (j % (NX + 1)) === 0 ? 1 : 0;                // en soldaki sütun
      aX[j] = X[j]; aZ[j] = Z[j];
    }
    write();
  }

  function write() {
    for (var j = 0; j < n; j++) { pos.setXYZ(j, X[j], Y[j], Z[j]); }
    pos.needsUpdate = true;
    geo.computeVertexNormals();
  }

  /* Bir fizik adımı. rollLen = ruloda kalan kumaş; curl = köşe hafızası kuvveti (0..1) */
  /* ⚠⚠ ÖLÇÜLDÜ: hedef konumları YATAY SIKIŞTIRMAK baskıyı bozuyordu — doku haritası
     düzlemle birebir olduğu için X aralığı daralınca görsel eziliyor (ölçüm: aralık
     dinlenme boyunun 0.03 katına kadar düştü, yer yer 1.39'a gerildi, eksiye bile
     indi). Kumaşın fazlalığı YATAYDA değil DİKEYDE (Z) çözülmeli — gerçek kumaş da
     öyle yapar: boy korunur, fazlalık dalga olur. Bu yüzden hedef = GERÇEK konum. */
  function flatTargetX(x) { return x; }

  function step(rollLen) {
    var x0 = W / 2 - rollLen;
    var xw = rollX(x0);                 // rulonun DÜNYA konumu (kumaştan geride kalır)
    var R = R0 * (0.5 + 0.5 * Math.sqrt(Math.max(0, rollLen) / (W * 0.8)));
    var j, vx, vy, vz;

    for (j = 0; j < n; j++) {
      if (anchor[j]) {                                   // sabit uç: hareket etmez
        X[j] = flatTargetX(bx[j]); Y[j] = by[j]; Z[j] = aZ[j];
        oX[j] = X[j]; oY[j] = Y[j]; oZ[j] = Z[j];
        free[j] = 0;
        continue;
      }
      if (bx[j] > x0 && rollLen > 1e-4) {
        /* HÂLÂ RULODA: konumu spiral belirler. Önceki kareyi de spiralden bıraktığımız
           için, serbest kaldığı an rulonun teğet hızını doğal olarak miras alır. */
        oX[j] = X[j]; oY[j] = Y[j]; oZ[j] = Z[j];
        spiral(bx[j], xw, R, tmp);
        X[j] = tmp[0]; Y[j] = by[j]; Z[j] = tmp[2];
        free[j] = 0;
        continue;
      }
      if (!free[j]) {
        /* Rulodan YENİ çıktı. Kusursuz simetrik bir sıkışma yön seçemez ve asla
           burkulmaz (ölçüldü: genlik 0.0000) — gerçek kumaş da dokusu düzgün olmadığı
           için hep bir yöne kıvrılır. Bırakırken minik, DETERMİNİST bir sapma veriyoruz;
           dalganın şeklini fizik belirliyor, biz sadece "hangi yöne" sorusunu açıyoruz. */
        Z[j] += (Math.sin(bx[j] * 91.7 + by[j] * 47.3) + Math.sin(by[j] * 133.1)) * 0.0024 * H;
        free[j] = 1;
      }
      vx = (X[j] - oX[j]) * DAMP; vy = (Y[j] - oY[j]) * DAMP; vz = (Z[j] - oZ[j]) * DAMP;
      oX[j] = X[j]; oY[j] = Y[j]; oZ[j] = Z[j];
      X[j] += vx; Y[j] += vy; Z[j] += vz + GRAV * (1 / 3600);
      /* Şekil hafızası: ruloda EN SON kalan kenar (sağ), zemine yakınken hafifçe
         yukarı kıvrılmak ister — gerçek kanvasın köşe kıvrımının sebebi budur. */
      /* Ali (2026-07-29): köşe kıvrımı İSTENMİYOR — kumaş tam açık serilsin.
         Yalnız fizikten gelen doğal hafif dalgalanma kalır (levha gibi durmasın). */
    }

    /* ⭐ Açılma bittiğinde SERBEST UÇ DÜZ OTURUR (Ali: "ucu kıvrık kalmasın, kötü
       görünüyor"). Fazlalık kumaş en son bırakılan kenarda birikip orayı kaldırıyordu;
       burada son sütunlar hedef düz konumlarına yaylanır — gerçekte de serdikten sonra
       ucu elinle düzeltirsin. Fazlalık böylece yüzeye yayılıp doğal dalga olarak kalır. */
    /* ⭐ ÖLÇÜLDÜ: fazlalık kumaş rulonun TEMAS NOKTASINDA üst üste biniyordu —
       açılma boyunca yüzlerce katlanma (595 @ %12 rulo), hepsi uçta; ön/arka yüz
       çakışınca "bozuk/karışık" şerit görünüyordu ve ancak rulo bitince düzeliyordu.
       Gerçek kumaş da böyle davranmaz: indiği yerde dalgalanır, GERİDE oturur.
       Bu yüzden serme noktasının yakını serbest, gerisi yumuşakça düzleşiyor. */
    if (rollLen > 1e-4 && !(typeof window !== 'undefined' && window.__ipNoSettle)) {
      var back0 = 0.04 * W, back1 = 0.30 * W;
      for (j = 0; j < n; j++) {
        if (anchor[j] || !free[j]) continue;
        var behind = x0 - bx[j];
        if (behind <= back0) continue;                  // taze serilen bölge: dokunma
        var q = Math.min(1, (behind - back0) / (back1 - back0));
        var kq = 0.11 * q * q;
        X[j] += (flatTargetX(bx[j]) - X[j]) * kq;
        Y[j] += (by[j] - Y[j]) * kq;
      }
    }

    if (rollLen <= 1e-4) {
      relaxSlack();                                     // fazlalığı yavaşça sal
      /* ⚠ ÖLÇÜLDÜ: fazlalığı salmak MEVCUT katlanmayı açmıyor — katlanmış bir kumaş
         mesafe kısıtları açısından düz olan kadar geçerli bir dengedir (yerel minimum),
         kendiliğinden çözülmez (175→43'te takıldı). Bu yüzden kumaşı düzlem hedefine
         doğru NAZİKÇE toparlıyoruz: katlanma büyük konum sapması olduğu için hızla
         açılır, küçük dalgalar ise dokuma düzensizliğinden beslendiği için kalır. */
      for (j = 0; j < n; j++) {
        if (anchor[j]) continue;
        var edge0 = W / 2 - W * 0.14;
        var kk = 0.03;                                  // genel toparlama
        if (bx[j] > edge0) {                            // serbest uç daha kararlı otursun
          var k = (bx[j] - edge0) / (W * 0.14);
          kk = 0.03 + 0.22 * k * k;
          Z[j] += (0 - Z[j]) * kk;
        }
        X[j] += (flatTargetX(bx[j]) - X[j]) * kk;
        Y[j] += (by[j] - Y[j]) * kk;
      }
    }

    for (var it = 0; it < ITER; it++) {
      for (var k = 0; k < NC; k++) {
        var a = CA[k], b = CB[k];
        var dx = X[b] - X[a], dy = Y[b] - Y[a], dz = Z[b] - Z[a];
        var dist = Math.sqrt(dx * dx + dy * dy + dz * dz) || 1e-6;
        var diff = (dist - CL[k]) / dist * 0.5;
        var fa = free[a], fb = free[b];
        if (!fa && !fb) continue;
        var wa = fa ? (fb ? 1 : 2) : 0, wb = fb ? (fa ? 1 : 2) : 0;
        var ox = dx * diff, oy = dy * diff, oz = dz * diff;
        X[a] += ox * wa; Y[a] += oy * wa; Z[a] += oz * wa;
        X[b] -= ox * wb; Y[b] -= oy * wb; Z[b] -= oz * wb;
      }
      for (j = 0; j < n; j++) {                          // zemin: kumaş yerin altına geçemez
        if (free[j] && Z[j] < 0) {
          Z[j] = -Z[j] * 0.12;                           // zemin tam soğurmaz; küçük esneklik
          X[j] += (oX[j] - X[j]) * GROUND_FRICTION;      // sürtünme → kayarak durur
          Y[j] += (oY[j] - Y[j]) * GROUND_FRICTION;
        }
      }
    }
    write();
  }

  /* Kumaş durdu mu? (durunca kareleri boşa harcamayalım) */
  function energy() {
    var e = 0;
    for (var j = 0; j < n; j += 7) {
      var vx = X[j] - oX[j], vy = Y[j] - oY[j], vz = Z[j] - oZ[j];
      e += vx * vx + vy * vy + vz * vz;
    }
    return e;
  }

  /* test kancası: kumaşın DÜZ kısmındaki dikey sapma (dalga genliği) ölçülebilsin */
  function stats(rollLen) {
    var x0 = W / 2 - rollLen, lo = 1e9, hi = -1e9, cnt = 0;
    for (var j = 0; j < n; j++) {
      if (bx[j] > (W / 2 - rollLen) - 0.05) continue;
      if (Z[j] < lo) lo = Z[j];
      if (Z[j] > hi) hi = Z[j];
      cnt++;
    }
    /* ⚠ ÖLÇÜT DÜZELTİLDİ: katlanmayı yalnız SERİLMİŞ bölgede say. Ruloda X sırasının
       tersine dönmesi NORMALDİR (spiral zaten öyle), onu saymak ölçümü kirletiyordu.
       rev      = serilmiş kumaşın tamamındaki katlanma
       revFresh = temas noktasının hemen arkasındaki %15'lik taze bölge (Ali'nin
                  gördüğü "bozuk şerit" tam burada oluşuyordu) */
    /* DOKU GERİLMESİ: serilmiş bölgede komşu X aralığı ÷ dinlenme aralığı.
       1.0 = baskı bire bir; 0.9 = %10 sıkışmış (görsel ezilmiş) demektir. */
    var sMin = 9, sMax = 0, lay = W / 2 - rollLen;
    var rev = 0, revFresh = 0, fresh0 = lay - W * 0.15;
    for (var iy2 = 0; iy2 <= NY; iy2++) {
      for (var ix2 = 0; ix2 < NX; ix2++) {
        var q1 = iy2 * (NX + 1) + ix2;
        if (bx[q1 + 1] > lay - 0.001) continue;   // ruloda / temas noktasında: sayma
        if (X[q1 + 1] < X[q1]) { rev++; if (bx[q1] > fresh0) revFresh++; }
        var st1 = (X[q1 + 1] - X[q1]) / restX;
        if (st1 < sMin) sMin = st1;
        if (st1 > sMax) sMax = st1;
      }
    }
    var elo = 1e9, ehi = -1e9, e0 = W / 2 - W * 0.12;
    for (var q = 0; q < n; q++) {
      if (bx[q] < e0) continue;
      if (Z[q] < elo) elo = Z[q];
      if (Z[q] > ehi) ehi = Z[q];
    }
    return cnt ? { min: lo, max: hi, span: hi - lo, n: cnt, katlanma: rev, tazeKatlanma: revFresh,
                   gerilmeMin: (sMin > 8 ? 1 : sMin), gerilmeMax: (sMax || 1),
                   ucSpan: (ehi > -1e8 ? ehi - elo : 0), ucMax: (ehi > -1e8 ? ehi : 0) } : null;
  }
  return { place: place, step: step, energy: energy, stats: stats };
}
var rollAnim = null;                                    // {update, cur, target}
function buildDrapedCanvas(tex, W, H) {
  /* Simülasyon ağı = render ağı. 112×34 ≈ 3900 parçacık: ruloda kırılma görünmeyecek
     kadar sık, her karede 3 kısıt turu koşturulacak kadar hafif. */
  var NX = 112, NY = 34;
  var geo = new THREE.PlaneGeometry(W, H, NX, NY);
  var cloth = makeUnrollCloth(geo, W, H, NX, NY);
  /* Ali (2026-07-29): müşteriye "aç/kapa" düğmesi verilmez — kendiliğinden oynasın.
     Rulo olarak başlar, kumaş GERÇEK fizikle açılıp dalgalanır, zemine yayılır,
     köşesi şekil hafızasıyla hafif kıvrık kalır. */
  var CLOSED = W * 0.92;
  cloth.place(CLOSED);
  rollAnim = { cloth: cloth, cur: CLOSED, closed: CLOSED, calm: 0 };
  var front = faceMaterial('canvas', tex);
  front.side = THREE.FrontSide;
  front.bumpScale = 0.005;                              // baskıda kumaş dokusu NET hissedilsin
  var back = new THREE.MeshStandardMaterial({           // bej pamuk arka — örgü hem renkte hem kabartmada
    map: weaveColorTex(), bumpMap: weaveTex(), bumpScale: 0.005,
    metalness: 0, roughness: 0.96, envMapIntensity: 0.45,
    side: THREE.DoubleSide,
    polygonOffset: true, polygonOffsetFactor: 1, polygonOffsetUnits: 1,
  });
  var fabricG = new THREE.Group();
  var backMesh = new THREE.Mesh(geo, back); backMesh.renderOrder = 0;   // AYNI geometri → tek update
  var frontMesh = new THREE.Mesh(geo, front); frontMesh.renderOrder = 1;
  fabricG.add(backMesh); fabricG.add(frontMesh);
  fabricG.rotation.x = -Math.PI / 2;                    // zemine ser
  var g = new THREE.Group();
  g.add(fabricG);
  /* ⚠ ESKİ HÂLİ SORUNLUYDU (Ali): keskin kenarlı, kumaştan %12 büyük opak bir
     dikdörtgendi → göz onu "altta duran ikinci bir levha" sanıyordu ve müşteri
     gönderilecek malzemenin parçası zannedebiliyordu. Gerçek gölgenin düz kenarı
     olmaz: artık kenarları eriyen radyal gradyan. Mod test/karar için değiştirilebilir. */
  var shadow = makeShadow(W, H, shadowMode);
  if (shadow) g.add(shadow);
  g.userData.shadowRebuild = function (mode) {
    if (g.userData.shadowMesh) { g.remove(g.userData.shadowMesh); }
    var m = makeShadow(W, H, mode);
    g.userData.shadowMesh = m;
    if (m) g.add(m);
  };
  g.userData.shadowMesh = shadow;
  /* YALAYICI IŞIK — yalnız kanvasta. Sahnenin genel ışığı cam için kısıtlı (Ali:
     "yansıma görseli kapatıyor"); ama kumaşın dalgası ve örgüsü ancak alçak açılı
     ışıkla okunur. Kanvas mat olduğu için parlama riski yok. */
  var rake = new THREE.DirectionalLight(0xfff6ea, 0.62);
  rake.position.set(-1.3, 0.30, 0.55);
  g.add(rake);
  g.position.y = -H * 0.22;                             // sahnede hafif aşağıda dursun
  return g;
}

/* ⭐ SİNEMATİK AÇILIŞ (Ali): kamera uzaktan ve alçaktan başlar, kumaş açılırken
   yavaşça yaklaşıp yükselir. Yumuşak giriş-çıkış (smoothstep) → mekanik değil,
   çekim hissi. Kullanıcı sürüklerse hareket ANINDA bırakılır: kontrol her zaman
   müşterinin. */
var intro = null;
function startIntro(from, to, look, ms) {
  intro = { from: from, to: to, look: look, t: 0, dur: ms || 2600, last: 0 };
  camera.position.copy(from);
  controls.target.copy(look);
  controls.enabled = false;
}
function endIntro() {
  if (!intro) return;
  intro = null;
  controls.enabled = true;
}
function stepIntro() {
  var now = performance.now();
  if (!intro.last) intro.last = now;
  intro.t += now - intro.last;
  intro.last = now;
  var p = Math.min(1, intro.t / intro.dur);
  var e = p * p * (3 - 2 * p);                          // smoothstep
  camera.position.lerpVectors(intro.from, intro.to, e);
  controls.target.copy(intro.look);
  camera.lookAt(intro.look);
  if (p >= 1) endIntro();
}

function loop() {
  raf = requestAnimationFrame(loop);
  if (rollAnim) {
    /* Rulo, hızlanıp yavaşlayan bir tempoyla açılır (sabit hız mekanik durur).
       Kumaşın geri kalanını FİZİK yürütür; biz yalnız rulonun ne kadar açıldığını
       söylüyoruz. Kumaş tamamen durunca simülasyon uykuya geçer (CPU boşa gitmesin). */
    if (rollAnim.cur > 0) {
      /* Süre KARE SAYISINA değil SAATE bağlı: yavaş cihazda da ~3.2 sn'de açılır. */
      var now = performance.now();
      var dt = Math.min(0.05, (now - (rollAnim.last || now)) / 1000);
      rollAnim.last = now;
      /* ALT-ADIM: yavaş cihazda (veya sekme arka plandayken) tek karede rulo çok
         ilerleyip kumaşı buruşturuyordu. Fizik hep ~1/60'lık adımlarla ilerlesin. */
      var steps = Math.max(1, Math.min(4, Math.round(dt * 60)));
      var sdt = dt / steps;
      for (var st = 0; st < steps && rollAnim.cur > 0; st++) {
        var t = 1 - rollAnim.cur / rollAnim.closed;      // 0 → 1 açılma ilerlemesi
        var rate = 0.16 + 0.34 * Math.sin(Math.PI * Math.min(1, Math.max(0.05, t + 0.05)));
        rollAnim.cur = Math.max(0, rollAnim.cur - rollAnim.closed * rate * sdt);
        rollAnim.cloth.step(rollAnim.cur);
      }
      rollAnim.calm = 0;
      rollAnim.stepped = true;
    }
    if (rollAnim.calm < 90 && !rollAnim.stepped) {
      rollAnim.cloth.step(rollAnim.cur);
      if (rollAnim.cur <= 0 && rollAnim.cloth.energy() < 1e-7) rollAnim.calm++;
      else if (rollAnim.cur <= 0) rollAnim.calm = 0;
    }
    rollAnim.stepped = false;
  }
  if (intro) stepIntro();
  if (rollAnim && rollAnim.cloth.stats) {               // test kancası (üretimde zararsız)
    window.__ipCloth = { roll: rollAnim.cur / rollAnim.closed,
                         wave: rollAnim.cloth.stats(rollAnim.cur), intro: !!intro };
  }
  controls.update();
  renderer.render(scene, camera);
}

window.IP3D = {
  show: function (el, opts) {
    ensure(el); size();
    clearGroup();
    var ar = opts.wMM / opts.hMM;
    var H = 1, W = ar;                            // sahne ölçüsü (normalize)
    if (ar > 1.6) { W = 1.6; H = 1.6 / ar; }      // panoramikte taşma
    new THREE.TextureLoader().load(opts.texUrl, function (tex) {
      tex.colorSpace = THREE.SRGBColorSpace;
      tex.anisotropy = renderer.capabilities.getMaxAnisotropy();
      clearGroup();
      if (opts.material !== 'canvas') rollAnim = null;
      var obj = (opts.material === 'canvas')
        ? buildDrapedCanvas(tex, W, H)
        : buildPanel(tex, W, H, opts.kind, opts.material, opts.wMM, opts.hMM, opts.panels || null);
      group.add(obj);
      var dist = Math.max(1.7, Math.max(W, H) * 1.9);
      if (opts.material === 'canvas') {
        /* SİNEMATİK: alçak ve uzak bir açıdan (rulo siluet olarak görünür) yavaşça
           yukarı-öne süzülür; kumaş açılırken kadraj eseri kucaklar. */
        var look = new THREE.Vector3(0, -H * 0.22, 0);
        startIntro(
          new THREE.Vector3(dist * 0.62, dist * 0.20, dist * 1.15),   // uzak + alçak + yandan
          new THREE.Vector3(dist * 0.05, dist * 0.72, dist * 0.62),   // yukarıdan-önden (nihai kadraj)
          look, 3200);
      } else {
        endIntro();
        camera.position.set(dist * 0.12, dist * 0.06, dist);
        controls.target.set(0, 0, 0);
      }
    });
    if (!raf) loop();
  },
  hide: function () {
    if (raf) { cancelAnimationFrame(raf); raf = 0; }
  },
  /* Aç/kapa artık MÜŞTERİYE SUNULMUYOR (Ali: "kullanıcı bunu neden açıp kapatsın")
     — animasyon kendiliğinden oynuyor. Yalnız geliştirme/test için duruyor. */
  setShadow: function (mode) {                   // karar/testi görselle vermek için
    shadowMode = mode;
    group.children.forEach(function (c) {
      if (c.userData && c.userData.shadowRebuild) c.userData.shadowRebuild(mode);
    });
  },
  replayRoll: function () {                      // animasyonu baştan oynat (test/inceleme)
    if (!rollAnim) return;
    rollAnim.cur = rollAnim.closed; rollAnim.calm = 0; rollAnim.last = 0;
    rollAnim.cloth.place(rollAnim.cur);
  },
};
